// extracted by mini-css-extract-plugin
module.exports = {"errorContainer":"error_errorContainer__2pqwC","backHome":"error_backHome__1aKCg","backHomeSection":"error_backHomeSection__3MUF6","icon":"error_icon__VvtRD"};